import { useQuery } from '@tanstack/react-query'

import { getUserSidebarSummary } from '@/api/sidebarSummaryApi'

export const sidebarSummaryKeys = {
  all: ['user-sidebar-summary'] as const,
}

export function useUserSidebarSummary() {
  return useQuery({
    queryKey: sidebarSummaryKeys.all,
    queryFn: getUserSidebarSummary,
    staleTime: 15000,
    refetchInterval: 15000,
    refetchIntervalInBackground: true,
    refetchOnMount: 'always',
  })
}
